import React, { useState } from 'react';
import { TaskPickerProps } from './types';
import './TaskPicker.scss';
import { CloseButton } from 'react-bootstrap';
import { AddModal } from '../AddModal';
import { useTranslation } from 'react-i18next';

export const TaskPicker: React.FC<TaskPickerProps> = ({
  items,
  disabled,
  error,
  title,
  allowSpace = true,
  required,
  additionalInfo,
  onAddNewItem,
  onRemoveItem,
}) => {
  const { t } = useTranslation();
  const [showAddModal, setShowAddModal] = useState(false);

  const handleAddMoreClick = () => setShowAddModal(true);
  const handleAddModalClose = () => setShowAddModal(false);
  const handleAddModalSubmit = (item: string) => {
    onAddNewItem(item.trim());
    setShowAddModal(false);
  };

  const getRemoveItemHandler = (item: string) => () =>
    onRemoveItem(items?.filter((val) => val !== item) ?? []);

  return (
    <>
      <div className={`d-flex task-picker ${disabled && 'disabled'}`}>
        <label className="tag-label">
          {title || t('label_create-hashtag')}
          {required && <span className="required-indicator">*</span>}
          {additionalInfo && (
            <span className="additional-info">( {additionalInfo} )</span>
          )}
        </label>
        <ul>
          {items?.map((item) => (
            <li key={item} className="item">
              <span>{item}</span>
              <CloseButton
                variant="white"
                disabled={disabled}
                onClick={getRemoveItemHandler(item)}
              />
            </li>
          ))}

          {!disabled && (
            <li className="add-more-btn" onClick={handleAddMoreClick}>
              <span>+</span> {t('btn_click_to_add_more')}
            </li>
          )}
        </ul>
        {error && (
          <span className="error-text">
            {typeof error === 'object' ? error.join(', ') : error}
          </span>
        )}
      </div>

      <AddModal
        open={showAddModal}
        inputLabel={t('label_tag')}
        title={t('btn_add_tag')}
        allowSpace={allowSpace}
        onClose={handleAddModalClose}
        onSubmit={handleAddModalSubmit}
      />
    </>
  );
};
